import { Link } from 'react-router-dom';

const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'Products', path: '/products' },
  { label: 'About', path: '/about' },
  { label: 'Contact', path: '/contact' },
];

export default function Footer() {
  const styles = {
    footer: {
      background: '#1A1A1A',
      borderTop: '4px solid #E67E22',
      padding: '60px 24px 32px',
    },
    inner: {
      maxWidth: '1200px',
      margin: '0 auto',
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: '48px',
      marginBottom: '48px',
    },
    logoTop: {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 800,
      fontSize: '20px',
      color: '#FFFFFF',
      letterSpacing: '0.04em',
      display: 'block',
    },
    logoBottom: {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 600,
      fontSize: '12px',
      color: '#E67E22',
      letterSpacing: '0.06em',
      display: 'block',
      marginTop: '2px',
    },
    tagline: {
      fontFamily: 'Inter, sans-serif',
      fontSize: '14px',
      color: 'rgba(255,255,255,0.6)',
      marginTop: '12px',
      lineHeight: 1.6,
    },
    socialRow: {
      display: 'flex',
      gap: '12px',
      marginTop: '20px',
    },
    socialLink: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '36px',
      height: '36px',
      borderRadius: '8px',
      background: 'rgba(255,255,255,0.1)',
      color: '#FFFFFF',
      fontSize: '16px',
      transition: 'background 0.2s',
      textDecoration: 'none',
    },
    colTitle: {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 600,
      fontSize: '14px',
      color: '#E67E22',
      letterSpacing: '0.06em',
      textTransform: 'uppercase',
      marginBottom: '16px',
    },
    navList: {
      listStyle: 'none',
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
    },
    navItem: {
      fontFamily: 'Inter, sans-serif',
      fontSize: '14px',
      color: 'rgba(255,255,255,0.75)',
      transition: 'color 0.2s',
    },
    contactLine: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '10px',
      marginBottom: '12px',
    },
    contactIcon: {
      fontSize: '15px',
      marginTop: '1px',
      flexShrink: 0,
      color: '#E67E22',
    },
    contactText: {
      fontFamily: 'Inter, sans-serif',
      fontSize: '14px',
      color: 'rgba(255,255,255,0.75)',
      lineHeight: 1.5,
    },
    divider: {
      height: '1px',
      background: 'rgba(255,255,255,0.1)',
      margin: '0 0 24px',
    },
    bottom: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '8px',
    },
    copy: {
      fontFamily: 'Inter, sans-serif',
      fontSize: '13px',
      color: 'rgba(255,255,255,0.4)',
    },
    trading: {
      fontFamily: 'Inter, sans-serif',
      fontSize: '13px',
      color: 'rgba(255,255,255,0.3)',
    },
  };

  return (
    <footer style={styles.footer}>
      <div style={styles.inner}>
        <div style={styles.grid}>
          <div>
            <span style={styles.logoTop}>WHANGANUI</span>
            <span style={styles.logoBottom}>SPICES AND VEGES</span>
            <p style={styles.tagline}>
              Your local destination for fresh vegetables, premium spices and international groceries in Whanganui.
            </p>
            <div style={styles.socialRow}>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                style={styles.socialLink}
                aria-label="Facebook"
                onMouseEnter={(e) => { e.currentTarget.style.background = '#E67E22'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.1)'; }}
              >
                f
              </a>
            </div>
          </div>

          <div>
            <p style={styles.colTitle}>Navigation</p>
            <ul style={styles.navList}>
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    style={styles.navItem}
                    onMouseEnter={(e) => { e.currentTarget.style.color = '#E67E22'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.color = 'rgba(255,255,255,0.75)'; }}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p style={styles.colTitle}>Get in Touch</p>
            <div style={styles.contactLine}>
              <span style={styles.contactIcon}>&#128205;</span>
              <span style={styles.contactText}>Whanganui, New Zealand</span>
            </div>
            <div style={styles.contactLine}>
              <span style={styles.contactIcon}>&#128222;</span>
              <a href="tel:0634844398" style={{ ...styles.contactText, textDecoration: 'none' }}>06-348 4398</a>
            </div>
            <div style={styles.contactLine}>
              <span style={styles.contactIcon}>&#9993;</span>
              <a href="mailto:shiriwastowenterprises@gmail.com" style={{ ...styles.contactText, textDecoration: 'none', wordBreak: 'break-all' }}>
                shiriwastowenterprises@gmail.com
              </a>
            </div>
          </div>
        </div>

        <div style={styles.divider} />

        <div style={styles.bottom}>
          <p style={styles.copy}>&copy; {new Date().getFullYear()} Whanganui Spices and Veges. All rights reserved.</p>
          <p style={styles.trading}>Trading as Shiriwastow Enterprises Ltd</p>
        </div>
      </div>
    </footer>
  );
}
